"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#2A69F2" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.386 11.913l6.458-6.458L16.13 6.74l-7.744 7.744-4.75-4.75L4.922 8.45l3.464 3.464z", fill: "#fff" }))); };
exports.default = Component;
//# sourceMappingURL=LegacyCheck.js.map